import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";
import MenuActivite from "./Menu";
import {pdcsApiUpsellProvider} from "../../lib/api/providers";
import AuthRender from "../../containers/AuthRender";
import {SERVICES} from "../../configs/constants";
import {HighlightedText, PlaceholderText} from "../basepdc/Components/CustomSpan.component";
import moment from "moment";
import {Drawer, Spin} from "antd";
import Contact from "../../components/contact/Contact.component";
import InfosPdc from "../basepdc/detailPdc/Info.detailpdc";
import {get} from "../../containers/activite/map/map.utils";
import {retailerLogos} from "../../containers/activite/map/retailerLogos";
import KpiButton from "../../components/activite/buttons/KpiButton";
import permalink from "../../modules/stats/permalink";
import {AWS_URL} from "../../configs/config";

class Prepare extends Component {
  state = {
    pdc: null
  };

  async componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftIndex("planning");
    // this.props.setMenuLeftItemIndex("planning-list");
    const pdcId = this.props.match.params.pdcId;
    const responsePdc = await pdcsApiUpsellProvider.post(
        "/",
        { match: { pdc_id: parseInt(pdcId) } },
        {
          headers: {
            Authorization: this.props.token
          }
        }
    );
    if (!Array.isArray(responsePdc.data) || responsePdc.data.length !== 1) {
      alert("Point de contact non reconnu");
      return;
    }
    const pdc = responsePdc.data[0];
    let statQuery = permalink.dataToUrlQuery({
      "filters": {
        "product_range_properties": {
          "values": [
            "O"
          ],
          "dataSelected": [
            {
              "id": "O",
              "value": "O"
            }
          ]
        },
        "client_id": {
          "values": [
            this.props.currentClientId
          ]
        },
        "pdc_id": {
          "values": [
            pdc.pdc_id
          ],
          "dataSelected": [
            {
              "id": pdc.pdc_id,
              "value": pdc.pdc_label
            }
          ]
        },
        "presence": {
          "values": [
            "miss"
          ],
          "dataSelected": []
        }
      },
      "kpiSelected": 10,
      "mainFilterSelected": "globale",
      "view": "summary",
      "summaryDimensions": [
        "brand",
        "product_ean"
      ],
      "summaryKpi": 10,
      "summaryDisplayType": "value",
      "summaryGainChecked": false
    });

    await this.setState({ pdc });
    await this.setState({ statQuery });
  }

  render() {
    const token = this.props.token;
    const pdc = this.state.pdc;
    const request = null;
    const typologie = get(["typology", "label"], pdc, "typologie non renseignée");
    const surface = get(["surface"], pdc, false);
    const contacts = get(["contacts"], pdc, {});
    const center = {
      lat: pdc && !isNaN(pdc.gps_lat) ? +pdc.gps_lat : null,
      lng: pdc && !isNaN(pdc.gps_long) ? +pdc.gps_long : null
    };
    const srcLogo = retailerLogos[pdc && pdc.retailer_id] ? `/img/retailer/${retailerLogos[pdc.retailer_id]}` : null;
    const missingNdLink = `/stats?query=${this.state.statQuery}`;
    return (
        <AuthRender service={SERVICES.PDC}>
          <div style={{ width: "100%", marginRight: 30, marginBottom: 30 }}>
            <div style={{ width: "100%", display: "flex" }}>
              <div className="p-w-1-3 p-flex-col">
                <div className="text-3xl font-bold text-gray-900 prepare-h2">Statistiques</div>
                <div className="kpis-container">
                  <KpiButton
                      label="DN manquante"
                      large={true}
                      path={missingNdLink}
                      // pdcId={`/stats/${this.props.match.params.pdcId}`}
                  />
                </div>
              </div>
                <div className="p-w-2-3 p-flex-col">
                  <div className="text-3xl font-bold text-gray-900 prepare-h2">Informations du point de contact</div>
                  {pdc && (
                      <Fragment>
                        <div className="p-flex p-pdc-detail-title">
                          <div className="p-w-1-2">
                            <div className="p-pdc-detail-name">
                              <HighlightedText request={request} field="pdc_label">
                                {pdc.pdc_label}
                              </HighlightedText>
                            </div>
                            <div style={{ display: "flex" }}>
                              {pdc.pdc_id ? <div className="p-pdc-detail-id">{pdc.pdc_id}</div> : <div></div>}
                              <div style={{ fontStyle: "italic", marginLeft: 30, verticalAlign: "center" }}>
                                Dernière màj le {moment(pdc.updated_at).format("DD-MM-YYYY")}
                              </div>
                            </div>
                          </div>
                          <div className="p-w-1-2 p-pdc-detail-title-right p-flex p-al-full p-al-v-center">
                            <div className="p-pdc-detail-typologie p-flex">
                              {srcLogo && <img src={srcLogo} className="p-pdc-detail-typologie-logo" />}
                              <div className="p-pdc-detail-typologie-text p-al-c-center">
                      <span>
                        <HighlightedText request={request} field={"typology"}>
                          <span className="p-pdc-detail-typologie-title">{typologie}</span> -{" "}
                        </HighlightedText>
                        {surface ? (
                            <div>
                              <HighlightedText request={request} field="surface">
                                {surface} m<sup>2</sup>
                              </HighlightedText>
                            </div>
                        ) : (
                            <PlaceholderText text={"Surface non renseignée"} />
                        )}
                      </span>
                                <br />
                                <HighlightedText request={request} field="retailer_label">
                                  {pdc.retailer_label || <PlaceholderText text={"Enseigne non renseignée"} />}
                                </HighlightedText>
                              </div>
                            </div>
                            <div className="p-btn p-btn-orange" onClick={() => this.setState({ isContactsVisible: true })}>
                              Contacts
                            </div>
                            <Drawer
                                title={"Contacts"}
                                placement="right"
                                closable={true}
                                onClose={() => this.setState({ isContactsVisible: false })}
                                getContainer={() => document.getElementById("root")}
                                visible={this.state.isContactsVisible}
                                width="400"
                            >
                              {Object.keys(contacts).length > 0
                                  ? contacts[this.props.currentClientId].map((contact, i) => (
                                      <Contact key={i} contact={contact} />
                                    ))
                                  : "Aucun contact renseigné"}
                            </Drawer>
                          </div>
                        </div>
                        <div className="p-flex p-pdc-detail-infos">
                          <InfosPdc pdc={pdc} request={request} />
                          <div className="p-w-1-2">
                            {pdc.photo_url ? (
                                <img className="p-pdc-detail-photo" src={`${AWS_URL}${pdc.photo_url}`} />
                            ) : (
                                <div
                                    style={{
                                      height: "100%",
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      border: "1px solid rgb(240, 240, 240)"
                                    }}
                                >
                                  <HighlightedText request={request} field="photo_url">
                                    <PlaceholderText text={"Pas de photo pour ce pdc"} />
                                  </HighlightedText>
                                </div>
                            )}
                          </div>
                        </div>
                      </Fragment>
                  )}
                  {!pdc && <Spin />}
                </div>
            </div>
          </div>
        </AuthRender>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label,
    currentClientId: (state.currentClient || {}).id,
    token: state.auth.token,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Prepare);



// WEBPACK FOOTER //
// src/pages/activite/Prepare.js